<template>
  <el-dropdown trigger="click" @command="onCommand" class="language-switcher">
    <span class="language-switcher__trigger">
      {{ currentLabel }} <i class="el-icon-d-caret language-switcher__caret"></i>
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        v-for="item in options"
        :key="item.value"
        :command="item.value"
      >
        {{ item.label }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { LOCALE_OPTIONS } from '@/i18n/constants';
import { setAppLocale } from '@/i18n';

export default {
  name: 'LanguageSwitcher',
  data: function () {
    return {
      options: LOCALE_OPTIONS,
    };
  },
  computed: {
    locale: function () {
      return this.$i18n.locale;
    },
    currentLabel: function () {
      var found = null;
      for (var i = 0; i < this.options.length; i++) {
        if (this.options[i].value === this.locale) {
          found = this.options[i];
          break;
        }
      }
      return found ? found.label : this.$t('common.language');
    },
  },
  methods: {
    onCommand: function (locale) {
      setAppLocale(locale);
    },
  },
};
</script>

<style scoped>
.language-switcher__trigger {
  cursor: pointer;
  font-weight: 500;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.87);
  white-space: nowrap;
}
.language-switcher__caret {
  margin-left: 4px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
}
</style>
